import React, { useEffect, useState } from "react";
import "./../Styles/Header.css";
import logo from "../assets/Main Logo.jpg";

const Header = ({ scrollToSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (section) => {
    setMenuOpen(false);
    scrollToSection(section);
  };

  return (
    <header className={`header ${scrolled ? "scrolled" : "over-light"}`}>
      <div className="header-inner">
        <button
          className="logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="True Bloom Tutoring home"
        >
          <img src={logo} alt="" />
          <span className="logo-text">
            True Bloom
            <span>Tutoring</span>
          </span>
        </button>

        <button
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          <ul>
            <li>
              <button onClick={() => go("whyUs")}>Why Us</button>
            </li>
            <li>
              <button onClick={() => go("results")}>Results</button>
            </li>
            <li>
              <button onClick={() => go("process")}>How It Works</button>
            </li>
            <li>
              <button onClick={() => go("reviews")}>Reviews</button>
            </li>
            <li>
              <button onClick={() => go("myStory")}>Our Story</button>
            </li>
          </ul>
          <button className="btn header-cta" onClick={() => go("contact")}>
            Book Free Intro Call
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
